import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface TagsReducer {
    tags: any[] | null;
}

const initialState: TagsReducer = {
    tags: null,
};

const tagsReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.TAGS.SEARCH_TAG:
            return {
                ...state,
                tags: action.payload,
            };

        default:
            return state;
    }
};

export default tagsReducer;
